var map = {
	"./CurrentAffairs": [
		96140,
		6140
	],
	"./CurrentAffairs.json": [
		96140,
		6140
	],
	"./EarthAndEnvironment": [
		52561,
		2561
	],
	"./EarthAndEnvironment.json": [
		52561,
		2561
	],
	"./IndiaAndTheWorld": [
		44748,
		4748
	],
	"./IndiaAndTheWorld.json": [
		44748,
		4748
	],
	"./LanguageAndLiterature": [
		48203,
		8203
	],
	"./LanguageAndLiterature.json": [
		48203,
		8203
	],
	"./LifeSkills": [
		17165,
		7165
	],
	"./LifeSkills.json": [
		17165,
		7165
	],
	"./MathsFun": [
		40669,
		669
	],
	"./MathsFun.json": [
		40669,
		669
	],
	"./MeAndMySurroundings": [
		80609,
		609
	],
	"./MeAndMySurroundings.json": [
		80609,
		609
	],
	"./PlantsAndAnimals": [
		54757,
		4757
	],
	"./PlantsAndAnimals.json": [
		54757,
		4757
	],
	"./ScienceAndTechnology": [
		74872,
		4872
	],
	"./ScienceAndTechnology.json": [
		74872,
		4872
	],
	"./Sports": [
		458,
		458
	],
	"./Sports.json": [
		458,
		458
	],
	"./TransportAndCommunication": [
		31605,
		1605
	],
	"./TransportAndCommunication.json": [
		31605,
		1605
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2700;
module.exports = webpackAsyncContext;